import { generateSetChild, generateUpdateArrayChild, generateAddArrayChild } from '@/helpers/VuexHelpers'
import { config } from '@/config'

export default {
	namespaced: true,
	state: {
		messages: []
	},
	actions: {
		addMessage({commit}, {message}) {
			commit('addMessage', {item: message})
		},
		clearMessages({commit}) {
			commit('setMessages', {item: []})
		}
	},
	getters: {
		notifyMessages(state) {
			return state.messages
		}
	},
	mutations: {
		addMessage: generateAddArrayChild("messages"),
		setMessages: generateSetChild("messages")
	}
}